module.exports = __webpack_public_path__ + "static/img/down-color.abd0cad9.svg";